export const iconFontAwesomeDevicesHardwareTablet = (
	<i className="fa-solid fa-tablet"></i>
);
